import Vue from "vue"
import DefaultTemplateTags from "@/enums/tagTemplates.js";
import numeral from 'numeral'
import "numeral/locales/pt-br";
numeral.locale('pt-br');

export default {

  namespaced: true,

  state: () => ({
    selectedProducts: [],
    products: [],
    tag: DefaultTemplateTags[0],
  }),


  getters: {
    getProducts(state, getters) {
      return localStorage.getItem('products')

    }
  },
  mutations: {
    addProduct(state, { product, quantity }) {
      let productData = {
        quantity: quantity,
        id: product.id,
        gtin: product.gtin,
        base_sku_id: product.base_sku_id,
        brand: product.brand,
        description: product.description,
        price: product.price,
        price_payment_on_terms: product.price_payment_on_terms,
        price_payment_immediate: product.price_payment_immediate
      }
      state.selectedProducts.push(productData);
    },

    increaseProduct(state, { product, quantity }) {
      let productData = {
        id: product.id,
        gtin: product.gtin,
        base_sku_id: product.base_sku_id,
        brand: product.brand,
        description: product.description,
        price: numeral(parseFloat(product.product_variant[0].price)).format('0,0.' + "0".repeat(2)),
        price_payment_on_terms: numeral(parseFloat(product.product_variant[0].price_payment_on_terms)).format('0,0.' + "0".repeat(2)),
        price_payment_immediate: numeral(parseFloat(product.product_variant[0].price_payment_immediate)).format('0,0.' + "0".repeat(2))
      }

      state.products.push(productData);

      this.commit("productsPrintTag/setProducts");


      let productIndex = state.selectedProducts
        .map(row => row.id)
        .indexOf(product.id);

      if (productIndex >= 0) {
        state.selectedProducts[productIndex].quantity = parseFloat(state.selectedProducts[productIndex].quantity) + parseFloat(quantity)
      } else {
        this.commit("productsPrintTag/addProduct", { product: product, quantity: quantity });
      }
    },

    decreaseProduct(state, product) {
      let productIndex = state.selectedProducts
        .map(row => row.id)
        .indexOf(product.id);
      if (state.selectedProducts[productIndex]) {
        if (state.selectedProducts[productIndex].quantity > 1) {
          state.selectedProducts[productIndex].quantity--;
        } else {
          state.selectedProducts.splice(productIndex, 1);
        }
        this.commit("productsPrintTag/removeProduct", product);
      }
    },

    removeProduct(state, product) {
      let productIndex = state.products
        .map(row => row.id)
        .indexOf(product.id);

      state.products.splice(productIndex, 1);
      this.commit("productsPrintTag/setProducts");
    },

    setProducts(state) {
      localStorage.setItem("products", JSON.stringify(state.products));
    }
  },

  actions: {}

}
